<div class="full-screen-content-wrapper"><router-outlet></router-outlet></div>
